import { SimulationStatus } from '@/api';
import { connectColors } from '@/theme/colors';
import type { CSSProperties } from 'react';
import {
  CurrentVersionStatus,
  type VersionStatus,
} from '../simulation-tool-page/utils/simulation-types';

type Option = {
  value: VersionStatus;
  variant: 'accent' | 'primary' | 'neutral' | 'negative' | 'warning';
  tagLabel: string;
  style?: CSSProperties;
};

export const STATUS_OPTIONS: Option[] = [
  {
    value: SimulationStatus.Draft,
    variant: 'accent',
    tagLabel: 'Draft',
  },
  {
    value: SimulationStatus.GlobalReview,
    variant: 'primary',
    tagLabel: 'Global Review',
  },
  {
    value: SimulationStatus.LocalReview,
    variant: 'primary',
    tagLabel: 'Local Review',
    style: {
      background: connectColors.core.purple[100],
      color: connectColors.core.purple[1100],
    },
  },
  {
    value: SimulationStatus.Published,
    variant: 'neutral',
    tagLabel: 'Published',
  },
  {
    value: SimulationStatus.Error,
    variant: 'negative',
    tagLabel: 'Error',
  },
  {
    value: CurrentVersionStatus,
    variant: 'warning',
    tagLabel: 'Current',
  },
] as const;

export const getStatusOption = (value: VersionStatus) =>
  STATUS_OPTIONS.find((o) => o.value === value);

export const SYSTEM_ASSIGNED_STATUSES: VersionStatus[] = [
  SimulationStatus.Published,
  SimulationStatus.Error,
  CurrentVersionStatus,
];

export const USER_SELECTABLE_STATUSES = STATUS_OPTIONS.filter(
  (
    s,
  ): s is Extract<
    (typeof STATUS_OPTIONS)[number],
    { value: SimulationStatus }
  > => !SYSTEM_ASSIGNED_STATUSES.includes(s.value),
);
